import React, { useState } from "react";
import { v4 as uuid } from "uuid";

import ChartSection from "./ChartSection";
import { getDisplayNameFromKey } from "../utils";
import FilterIcon from "../..//../assets/img/dashboard/filter-butn.svg";
import ReactTooltip from "react-tooltip";

const ChartMain = ({
    getSmartChartMasterFilterDropDown,
    projectsDropdownData,
    projectId,
    setSmartChartData,
    chartData,
    masterFilterList,
    openChartItemConfigModal,
    chartKeys = [],
    copyChartData,
    entity,
    selectedClient,
    isEdit,
    toggleImageListForBandModal,
    toggleImageBandDeleteConfirmationModal,
    editImageBand,
    addDocumentTile,
    toggleAddCAband,
    updatePageBreakConfig,
    addOnepagerTile,
    addOnepagerAssetTile,
    isExcelExport,
    isSkeletonView,
    requiredFields,
    setFilterOpenModal,
    handleShowDocPreview,
    isPreviewDocLoading,
    selectedDocPreview,
    setHeaderModal,
    updateDocHeaderConfig,
    addExecutiveSummaryBandFromApi,
    executiveSummaryBandLoading = false,
    openExecutiveSummaryHierarchyConfig
}) => {
    const [filterOpen, setFilterOpen] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);
    let filterCount = 0;
    const data = Object.keys(chartData[entity]?.band1?.mfilter)
        .filter(key => key !== "client_ids" && key !== "start_year" && key !== "update_fci" && chartData[entity]?.band1?.mfilter[key] !== "")
        .map(key => ({ [key]: chartData[entity]?.band1?.mfilter[key] }));
    data.forEach(obj => {
        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value) && value.length > 0) {
                filterCount++;
            } else if (typeof value === "object" && value !== null) {
                Object.values(value).forEach(innerValue => {
                    if (
                        (innerValue?.key !== "" && innerValue?.key !== null) ||
                        ((innerValue?.filters?.[0] === "null" ||
                            innerValue?.filters?.[0] === "not_null" ||
                            innerValue?.filters?.[0] === "count_gt_1") &&
                            (innerValue?.key === "" || innerValue?.key === null))
                    ) {
                        filterCount++;
                    }
                });
            } else if (key === "end_year" && value) {
                filterCount++;
            }
        });
    });

    return (
        <div class="card">
            <ReactTooltip id={`chart-main-tooltip`} effect="solid" place="bottom" backgroundColor="#007bff" />
            <div className={`card-header ${isEdit && Object.keys(chartData[entity].band1.type).length ? "bg-th-filtered" : ""}`}>
                <div className="icon">
                    <img src="/img/icon-squre.svg" alt="icon" />
                </div>
                <div
                    className="heading-text"
                    aria-expanded={!isCollapsed}
                    aria-controls={`collapseOne${entity}`}
                    onClick={() => {
                        setIsCollapsed(!isCollapsed);
                        entity === "project" && setShowFilter(!showFilter);
                    }}
                >
                    <h3>{getDisplayNameFromKey(entity)}</h3>
                    {entity === "project" && showFilter && (
                        <button
                            className="filter-button blue-common-btn cursor-pointer btn-add-img ml-2"
                            data-tip="View Filters"
                            data-for="dashboard-icons-right"
                            onClick={e => {
                                e.stopPropagation();
                                setFilterOpen(true);
                            }}
                        >
                            <img src={FilterIcon} alt="Filter Icon" />
                            <span> Filters</span>
                            {filterCount > 0 && <span className="notifyTxt">{filterCount}</span>}
                        </button>
                    )}
                </div>
                {entity === "project" && showFilter && !isExcelExport ? (
                    <button
                        class={`filter-button blue-common-btn heading-blue-button ${(chartData?.[entity]?.band1?.custom_header_keys || [])?.length ? "filter-button" : ""}`}
                        data-tip="View Filters"
                        data-for="dashboard-icons-right"
                        currentitem="false"
                        onClick={setHeaderModal}
                    >
                        <span className={`pr-2 pl-2`}> Page Header Config</span>
                        {(chartData?.[entity]?.band1?.custom_header_keys || [])?.length > 0 && (
                            <span className="notifyTxt">{(chartData?.[entity]?.band1?.custom_header_keys || [])?.length}</span>
                        )}
                    </button>
                ) : null}
                <div className="check-box-area">
                    <label className="container-check green-check">
                        Select All Charts
                        <input
                            type="checkbox"
                            name="is_bold"
                            checked={chartData?.[entity]?.band1?.type && chartKeys.length === Object.keys(chartData[entity].band1.type).length}
                            onClick={e => {
                                e.stopPropagation();
                                setSmartChartData("selectAll", {
                                    isSelectAll: e.target.checked,
                                    bandName: "band1",
                                    entity: entity
                                });
                            }}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>
            <div id={`collapseOne${entity}`} className={`collapse ${!isCollapsed ? "show" : ""}`} aria-labelledby={`headingOne${entity}`}>
                <div className="card-body">
                    <div className="btn-sec">
                        <button
                            className={`btn btn-file-add  ml-2 ${isExcelExport ? "disabled-btn" : ""}`}
                            onClick={() => !isExcelExport && addDocumentTile(entity)}
                        >
                            <img src="/img/blue-pls.svg" /> User Document
                        </button>
                        {entity === "project" ? (
                            <>
                                <button className={`btn btn-file-add ml-2`} onClick={() => toggleAddCAband(entity)}>
                                    <img src="/img/blue-pls.svg" /> Comparative Analysis Band
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2`}
                                    onClick={() =>
                                        setSmartChartData("custom_tile", {
                                            bandName: "band1",
                                            entity: entity,
                                            customTileKey: "normal_recom" + uuid(),
                                            customTileData: {
                                                band1: {
                                                    mfilter: { recommendations: [] },
                                                    settings_id: "",
                                                    name: "Recommendation Table",
                                                    remove_section_break: false
                                                }
                                            }
                                        })
                                    }
                                >
                                    <img src="/img/blue-pls.svg" /> Recommendation Table
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2 ${isExcelExport ? "disabled-btn" : ""}`}
                                    onClick={() =>
                                        !isExcelExport &&
                                        setSmartChartData("custom_tile", {
                                            bandName: "band1",
                                            entity: entity,
                                            customTileKey: "multi_recommendation" + uuid(),
                                            customTileData: {
                                                with_notes: true,
                                                name: "",
                                                remove_section_break: false,
                                                recommendations: [],
                                                key_name: {}
                                            }
                                        })
                                    }
                                >
                                    <img src="/img/blue-pls.svg" /> Recommendation Summary
                                </button>

                                <button
                                    className={`btn btn-file-add ml-2 ${isExcelExport ? "disabled-btn" : ""}`}
                                    onClick={() => !isExcelExport && addOnepagerTile()}
                                >
                                    <img src="/img/blue-pls.svg" /> Recommendation One Pager
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2 ${
                                        isExcelExport || Object.keys(chartData[entity]?.band1?.type ?? {}).some(e => e.startsWith("asset-onepager"))
                                            ? "disabled-btn"
                                            : ""
                                    }`}
                                    onClick={() => !isExcelExport && addOnepagerAssetTile("project")}
                                    disabled={Object.keys(chartData[entity]?.band1?.type ?? {}).some(e => e.startsWith("asset-onepager"))}
                                >
                                    <img src="/img/blue-pls.svg" /> Asset One Pager
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2 ${isExcelExport ? "disabled-btn" : ""}`}
                                    onClick={() =>
                                        !isExcelExport &&
                                        setSmartChartData("custom_tile", {
                                            bandName: "band1",
                                            entity: entity,
                                            customTileKey: "multisystem_" + uuid(),
                                            customTileData: isExcelExport
                                                ? { table_view: "", remove_tbl_section_break: false, combination: false }
                                                : {
                                                      table_view: "",
                                                      summary_view: {
                                                          chart_type: ["pie_3d"],
                                                          remove_section_break: false,
                                                          config: {
                                                              legend: true,
                                                              color_legend: true,
                                                              header: true,
                                                              total: true,
                                                              sort_by: { name: "asc" }
                                                          }
                                                      },
                                                      detailed_view: {
                                                          chart_type: ["stacked_column_2d"],
                                                          remove_section_break: false,
                                                          config: {
                                                              legend: true,
                                                              color_legend: true,
                                                              header: true,
                                                              total: true,
                                                              sort_by: { name: "asc" }
                                                          }
                                                      },
                                                      normal_recom: {
                                                          band1: {
                                                              mfilter: chartData[entity]?.band1?.mfilter ?? {},
                                                              remove_section_break: false,
                                                              name: "Recommendations",
                                                              config_filter: {}
                                                          }
                                                      },
                                                      remove_tbl_section_break: false,
                                                      combination: false
                                                  }
                                        })
                                    }
                                >
                                    <img src="/img/blue-pls.svg" /> System
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2 ${
                                        chartData[entity]?.band1?.mfilter?.building_ids?.length !== 1 || isExcelExport ? "disabled-btn" : ""
                                    }`}
                                    onClick={() =>
                                        setSmartChartData("custom_tile", {
                                            bandName: "band1",
                                            entity: entity,
                                            customTileKey: "building_report_" + uuid(),
                                            customTileData: {
                                                band1: { mfilter: { ...(chartData[entity]?.band1?.mfilter || {}) }, name: "BBI/Stoplight Chart" }
                                            }
                                        })
                                    }
                                    disabled={chartData[entity]?.band1?.mfilter?.building_ids?.length !== 1 || isExcelExport}
                                >
                                    <img src="/img/blue-pls.svg" /> BBI/Stoplight Chart
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2 ${
                                        chartData[entity]?.band1?.mfilter?.site_ids?.length !== 1 || isExcelExport ? "disabled-btn" : ""
                                    }`}
                                    onClick={() =>
                                        setSmartChartData("custom_tile", {
                                            bandName: "band1",
                                            entity: entity,
                                            customTileKey: "site_report_" + uuid(),
                                            customTileData: {
                                                band1: { mfilter: { ...(chartData[entity]?.band1?.mfilter || {}) }, name: "BSI/Stoplight Chart" }
                                            }
                                        })
                                    }
                                    disabled={chartData[entity]?.band1?.mfilter?.site_ids?.length !== 1 || isExcelExport}
                                >
                                    <img src="/img/blue-pls.svg" /> BSI/Stoplight Chart
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2 ${
                                        chartData[entity]?.band1?.mfilter?.addition_ids?.length !== 1 || isExcelExport ? "disabled-btn" : ""
                                    }`}
                                    onClick={() =>
                                        setSmartChartData("custom_tile", {
                                            bandName: "band1",
                                            entity: entity,
                                            customTileKey: "addition_report_" + uuid(),
                                            customTileData: {
                                                band1: { mfilter: { ...(chartData[entity]?.band1?.mfilter || {}) }, name: "BAI/Stoplight Chart" }
                                            }
                                        })
                                    }
                                    disabled={chartData[entity]?.band1?.mfilter?.addition_ids?.length !== 1 || isExcelExport}
                                >
                                    <img src="/img/blue-pls.svg" /> BAI/Stoplight Chart
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2 ${isExcelExport ? "disabled-btn" : ""}`}
                                    onClick={() =>
                                        !isExcelExport &&
                                        setSmartChartData("custom_tile", {
                                            bandName: "band1",
                                            entity: entity,
                                            customTileKey: "memo_field_" + uuid(),
                                            customTileData: {
                                                name: "Text Band",
                                                remove_section_break: false,
                                                key_name: {}
                                            }
                                        })
                                    }
                                >
                                    <img src="/img/blue-pls.svg" />
                                    Text Band
                                </button>
                            </>
                        ) : null}

                        {entity === "assets" && (
                            <button
                                className={`btn btn-file-add ml-2 ${isExcelExport ? "disabled-btn" : ""}`}
                                onClick={() => !isExcelExport && addOnepagerAssetTile("assets")}
                            >
                                <img src="/img/blue-pls.svg" /> Asset One Pager
                            </button>
                        )}
                        {entity === "energy_mng" && (
                            <button
                                className={`btn btn-file-add ml-2 ${isExcelExport ? "disabled-btn" : ""}`}
                                onClick={() =>
                                    !isExcelExport &&
                                    setSmartChartData("custom_tile", {
                                        bandName: "band1",
                                        entity: entity,
                                        customTileKey: "memo_field_" + uuid(),
                                        customTileData: {
                                            name: "Text Band",
                                            remove_section_break: false,
                                            key_name: {}
                                        }
                                    })
                                }
                            >
                                <img src="/img/blue-pls.svg" />
                                Text Band
                            </button>
                        )}
                        <button
                            className={`btn btn-file-add ml-2 ${isExcelExport ? "disabled-btn" : ""}`}
                            onClick={() =>
                                !isExcelExport &&
                                setSmartChartData("custom_tile", {
                                    bandName: "band1",
                                    entity: entity,
                                    customTileKey: "list_images" + uuid(),
                                    customTileData: { data: [], config: { type: 1 }, remove_section_break: false, show_captions: true }
                                })
                            }
                        >
                            <img src="/img/blue-pls.svg" /> Image Band
                        </button>
                        {entity === "project" ? (
                            <>
                                <button
                                    className={`btn btn-file-add ml-2 ${
                                        chartData[entity]?.band1?.mfilter?.building_ids?.length !== 1 || isExcelExport ? "disabled-btn" : ""
                                    }`}
                                    onClick={() =>
                                        !isExcelExport &&
                                        chartData[entity]?.band1?.mfilter?.building_ids?.length === 1 &&
                                        addExecutiveSummaryBandFromApi?.(entity)
                                    }
                                    disabled={chartData[entity]?.band1?.mfilter?.building_ids?.length !== 1 || isExcelExport}
                                    data-tip="Single Building Executive Summary"
                                    data-for="chart-main-tooltip"
                                >
                                    <img src="/img/blue-pls.svg" />
                                    <span className="tooltip-text">Single Building Executive Summary</span>
                                </button>
                                <button
                                    className={`btn btn-file-add ml-2 ${
                                        !chartData[entity]?.band1?.mfilter?.building_ids?.length ||
                                        chartData[entity]?.band1?.mfilter?.building_ids?.length === 1 ||
                                        isExcelExport
                                            ? "disabled-btn"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        !isExcelExport &&
                                        chartData[entity]?.band1?.mfilter?.building_ids?.length > 1 &&
                                        addExecutiveSummaryBandFromApi?.(entity, { isMultipleBuilding: true })
                                    }
                                    disabled={
                                        !chartData[entity]?.band1?.mfilter?.building_ids?.length ||
                                        chartData[entity]?.band1?.mfilter?.building_ids?.length == 1 ||
                                        isExcelExport
                                    }
                                    data-tip="Multiple Building Executive Summary"
                                    data-for="chart-main-tooltip"
                                >
                                    <img src="/img/blue-pls.svg" />
                                    <span className="tooltip-text">Multiple Building Executive Summary</span>
                                </button>
                            </>
                        ) : null}
                    </div>
                    {Object.keys(chartData[entity]).map((band, index) => {
                        return (
                            <ChartSection
                                handleShowDocPreview={handleShowDocPreview}
                                isPreviewDocLoading={isPreviewDocLoading}
                                selectedDocPreview={selectedDocPreview}
                                currentBand={band}
                                currentBandIndex={index}
                                getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                                projectsDropdownData={projectsDropdownData}
                                projectId={projectId}
                                setSmartChartData={setSmartChartData}
                                masterFilterList={masterFilterList}
                                chartSectionData={chartData[entity][band]}
                                openChartItemConfigModal={openChartItemConfigModal}
                                chartKeys={chartKeys}
                                copyChartSectionData={copyChartData?.[entity][band]}
                                entity={entity}
                                selectedClient={selectedClient}
                                toggleImageListForBandModal={toggleImageListForBandModal}
                                toggleImageBandDeleteConfirmationModal={toggleImageBandDeleteConfirmationModal}
                                editImageBand={editImageBand}
                                isEdit={isEdit}
                                updatePageBreakConfig={updatePageBreakConfig}
                                isExcelExport={isExcelExport}
                                isSkeletonView={isSkeletonView}
                                requiredFields={requiredFields}
                                setFilterOpenModal={setFilterOpenModal}
                                filterOpen={filterOpen}
                                setFilterOpen={setFilterOpen}
                                updateDocHeaderConfig={updateDocHeaderConfig}
                                entireChartData={chartData}
                                openExecutiveSummaryHierarchyConfig={openExecutiveSummaryHierarchyConfig}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
export default ChartMain;
